import useNavigationStore from "@/stores/navigation/store";
import useSelfExclusionStore from "@/stores/selfexclusion/store";
import {
  useDisclosure,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@nextui-org/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function GamblingWarning() {
  const { onOpenChange } = useDisclosure();
  const [isOpen, setOpen] = useState(true);
  const setProfileActiveTab = useNavigationStore(
    (state) => state.setProfileActiveTab,
  );
  const setSettingActiveTab = useNavigationStore(
    (state) => state.setSettingActiveTab,
  );
  const setOpenPopup = useSelfExclusionStore((state) => state.setOpenPopup);


  const navigate = useNavigate();


  const handleSelfExclusion = async () => {
    setProfileActiveTab("settings");
    setSettingActiveTab("responsible-gambling");
    setOpenPopup(false);
    navigate("/profile", { replace: true });
    setOpen(false);
  };

  return (
    <>
      {/* <div className="flex flex-row gap-5">
          <Button
            className="mt-3 rounded-md bg-gradient-to-r from-[#2998FF] to-[#1673DF]"
            onPress={onOpen}
          >
            Request Reactivate Account
          </Button>
        </div> */}
      <Modal
      //  backdrop="blur"
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="center"
        className="w-full sm:w-[30%] px-2 py-6 [background:linear-gradient(180deg,#092083_0%,#13204B_100%)]  rounded-lg"
        onClose={handleSelfExclusion}
        closeButton={<div></div>}
      >
        <ModalContent>
          {(onClose) => (
            <div className="flex w-full flex-col items-center justify-center">
              <img
                src="/assets/main/warning-icon.png"
                className="h-[80px] w-[80px]"
              />
              <ModalHeader className="flex flex-col gap-1 text-center text-[24px] font-medium leading-[20px] sm:px-5 text-white">
                You are currently in a self-exclusion period.
              </ModalHeader>
              <ModalBody>
                <p className="text-center text-[14px] font-normal leading-[20px] text-white/75 sm:px-5">
                  Your account is temporarily inactive, and you cannot perform
                  this action.
                </p>
              </ModalBody>
              <ModalFooter className="mt-2 flex flex-col-reverse sm:flex-row">
                {/* <Button onPress={onClose} className="w-full rounded-lg bg-[#14142A]">
                    Cancel
                  </Button> */}
                <Button
                  color="primary"
                  onPress={() => {
                    onClose();
                    handleSelfExclusion();
                  }}
                  className="w-full rounded-lg bg-gradient-to-r from-[#2998FF] to-[#1673DF]"
                  style={{
                    width: "100%",
                    // backgroundImage: "url('/profile/selfexclusion.webp')",
                    // backgroundSize: "cover",
                  }}
                >
                  Got It
                </Button>
              </ModalFooter>
            </div>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
